module.exports = __webpack_public_path__ + "media/images/athletes/1750-17ca5609b2e272ac34310156548d792c.png";